export default function line_user(state = null, action) {
    switch (action.type) {
        case 'LINE_USER_SET':
            return action.payload
        default:
            return state
    }
} 